module.exports = __webpack_public_path__ + "static/media/test5_2.4c937e44.png";